import { render, staticRenderFns } from "./StepSNS.vue?vue&type=template&id=e5a8e62c&scoped=true&"
import script from "./StepSNS.vue?vue&type=script&lang=js&"
export * from "./StepSNS.vue?vue&type=script&lang=js&"
import style0 from "./StepSNS.vue?vue&type=style&index=0&id=e5a8e62c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5a8e62c",
  null
  
)

export default component.exports